import * as firebase from 'firebase'

/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
export default {
  // the store configuration
  state: {
    admin: null
  },
  mutations: {  // changes the state of data properties
    setAdmin (state, payload) {
      state.admin = payload  // the currently signed in admin
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {  // to dispatch the mutations
    signAdminUp ({commit}, payload) {  // manage the user signup in our store
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {
            firebase.database().ref('admin/' + firebase.auth().currentUser.uid).set({
              company: payload.company,
              email: payload.email,
              admin: true,
              messageHistory: []
            })
            commit('setAdmin', {
              company: payload.company,
              email: payload.email,
              admin: true,
              messageHistory: []
            })
          }
        )
        .catch((error) => { console.log(error) })
    },
    signAdminIn ({commit}, payload) {  // payload is an object with an email and password
      // payload is what is currently in the store
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          user => {  // receive the user and store it in the store
            const newAdmin = {
              id: user.uid
            }
            commit('setAdmin', newAdmin)  // mutation and pass the new user
          }
        )
        .catch((error) => { console.log(error) })
    },
    autoAdminSignIn ({commit}, payload) {
      commit('setAdmin', {
        id: payload.uid
      })
    },
    fetchAdminData ({commit, getters}) {
      // commit('setLoading', true)

      // get admin data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      firebase.database().ref('/admin/').child(getters.admin.id).once('value')
        .then((data) => {
          let updatedAdmin = {
            id: getters.admin.id,
            company: data.child('company').val(),
            permission: data.child('admin').val()
          }
          commit('setAdmin', updatedAdmin)
        })
        .catch(error => { console.log(error) })
    },
    logoutAdmin ({commit}) {
      firebase.auth().signOut()
      commit('setAdmin', null)
    }
  },
  getters: {  // get the store in our components
    admin (state) {  // return the user from vuex store
      return state.admin
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/admin/index.js